import React from 'react';
import { Coins } from 'lucide-react';
import { DiscoveryRefusal } from '../../../types/discovery.types';
import { CreditRequestState } from '../../../hooks/useCreditRequest';
import { creditRequestContext } from '../../../utils/creditRequest';
import CreditRequestOutcome from '../../credits/CreditRequestOutcome';
import CreditRequestTrigger from '../../credits/CreditRequestTrigger';

/**
 * The refusal on Step 2 when the balance does not cover even one component
 * (or the credits service did not say what the balance is, so there is no
 * number of lines to offer). Nothing was charged, nothing was removed, and
 * the criteria are saved — so the copy is the backend's own sentence with the
 * real numbers, and the one thing the buyer can do: request more credits.
 */
export interface DiscoveryRefusedProps {
  refusal: DiscoveryRefusal;
  /** Display RFQ id for the credit request, e.g. RFQ-003. */
  rfqLabel?: string;
  /** "Request more credits": the state from `useCreditRequest` (`ConnectedDiscoveryRefused` supplies it). */
  creditRequest: CreditRequestState;
}

export const DiscoveryRefused: React.FC<DiscoveryRefusedProps> = ({ refusal, rfqLabel, creditRequest }) => {

  return (
    <div
      role="alert"
      className="flex flex-wrap items-start gap-s4 rounded-card border border-warn-border bg-warn-bg px-s6 py-[12px]"
    >
      <Coins className="mt-[1px] h-4 w-4 shrink-0 text-warn-ink" />
      <div className="flex min-w-[220px] flex-1 flex-col gap-s3">
        <div>
          <p className="m-0 text-row-title text-warn-ink">Not enough credits — I haven't started discovery</p>
          <p className="m-0 mt-[2px] text-body-sm text-ink-body">{refusal.message}</p>
        </div>
        <CreditRequestOutcome state={creditRequest} />
      </div>
      <CreditRequestTrigger
        state={creditRequest}
        onRequest={() => creditRequest.request(creditRequestContext(refusal, rfqLabel))}
        size="sm"
        className="shrink-0"
      />
    </div>
  );
};

export default DiscoveryRefused;
